function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMatchEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.6055 20.3945L19.7764 30.2236",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6055 30.2227L19.7764 20.3936",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15.5V8C30.5 3.85786 27.1421 0.5 23 0.5H9.07143C4.33756 0.5 0.5 4.33756 0.5 9.07143V23C0.5 27.1421 3.85786 30.5 8 30.5H15.5",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMatchEntry);
export default __webpack_public_path__ + "static/media/noMatchEntry.b2432c14c357aaf147ae7a779323393a.svg";
export { ForwardRef as ReactComponent };